import { render, staticRenderFns } from "./WorkShiftAdd.vue?vue&type=template&id=48947b4c&scoped=true&"
import script from "./WorkShiftAdd.vue?vue&type=script&lang=js&"
export * from "./WorkShiftAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48947b4c",
  null
  
)

export default component.exports